import { Directive, Input, ViewContainerRef, OnInit, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { TemplateDesignElementsRegistration } from './design-elements.map';
import { TemplateDesignElement } from './design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { Document } from 'src/app/modules/core/store/models/document.model';
import { Dataset } from '@app/modules/core/store/models/dataset.model';
import { FieldToValueMapping } from './design-elements.models';

@Directive({
    selector: '[topo-template-design-element]',
    standalone: false
})
export class TemplateDesignElementDirective implements OnInit {
  _control: CommunicationTemplateViewControl;
  _editMode: boolean;
  _index: number;
  _messageSettings: MessageSettings;
  _culture: string;
  _selected: boolean;

  @Input() set messageSettings(value: MessageSettings) {
    this._messageSettings = value;

    if (!!this.instance) {
      this.instance.messageSettings = value;
    }
  }

  @Input() template: CommunicationTemplate;

  @Input() set control(value: CommunicationTemplateViewControl) {
    this._control = value;
    this.loadComponent();
  }

  @Input() set editMode(value: boolean) {
    this._editMode = value;

    if (!!this.instance) {
      if (this._editMode === true) {
        this.instance.loadSettings();
      } else {
        this.instance.render();
      }
    }
  }

  @Input() set index(value: number) {
    this._index = value;

    if (!!this.instance) {
      this.instance.index = value;
    }
  }

  @Input() set culture(value: string) {
    this._culture = value;

    if (!!this.instance) {
      this.instance.culture = value;
    }
  }

  @Input() set selected(value: boolean) {
    this._selected = value;

    if (!!this.instance) {
      this.instance.selected = value;
    }
  }

  @Input() orgLanguages: string[];
  @Input() hasEdit: boolean;
  @Input() editable: boolean;

  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();
  @Output() hideControl = new EventEmitter();
  @Output() controlBusy = new EventEmitter();
  @Output() controlReady = new EventEmitter();

  instance: TemplateDesignElement;

  destroy$ = new Subject<void>();

  constructor(private view: ViewContainerRef, private resolver: ComponentFactoryResolver) {}

  ngOnInit() {}

  private loadComponent() {
    this.view.clear();

    const componentType = TemplateDesignElementsRegistration.find(
      r => r.channelUId === this.template.channelUId && r.viewControlType === this._control.controlType
    );
    if (!componentType) {
      return;
    }

    const factory = this.resolver.resolveComponentFactory(componentType.component);

    const component: any = this.view.createComponent(factory);
    this.instance = component.instance as TemplateDesignElement;

    if (!!!this.instance) {
      return;
    }

    this.instance.messageSettings = this._messageSettings;
    this.instance.template = this.template;
    this.instance.control = this._control;
    this.instance.culture = this._culture;
    this.instance.orgLanguages = this.orgLanguages;
    this.instance.settingsChanged = this.settingsChanged;
    this.instance.hideControl = this.hideControl;
    this.instance.controlBusy = this.controlBusy;
    this.instance.controlReady = this.controlReady;
    this.instance.selected = this._selected;
    this.instance.hasEdit = this.hasEdit;
    this.instance.editable = this.editable;
    this.instance.index = this._index;

    if (this._editMode === true) {
      this.instance.loadSettings();
    } else {
      this.instance.render();
    }
  }

  loadSettings(): void {
    if (this.instance) {
      this.instance.loadSettings();
    }
  }

  saveSettings(): boolean {
    if (this.instance) {
      return this.instance.saveSettings();
    } else {
      return true;
    }
  }

  render(): void {
    if (this.instance) {
      this.instance.render();
    }
  }

  edit(): void {
    if (this.instance) {
      this.instance.edit();
    }
  }

  setRuntimeData(data: any): void {
    if (this.instance) {
      this.instance.setRuntimeData(data);
    }
  }

  setDocumentContext(dataset: Dataset, document: Document, mapUId: string, mapping: FieldToValueMapping): void {
    if (this.instance && !!this.instance.setDocumentContext) {
      this.instance.setDocumentContext(dataset, document, mapUId, mapping);
    }
  }
}
